module.exports = __webpack_public_path__ + "img/user.47d33a1f.png";